/*
 * Selectors using reselect.
 */
import { createSelector } from 'reselect';

const rootSelector = state => state.app.confirmation;

export const hotelReservationSelector = createSelector(
  rootSelector,
  subState => subState.hotelReservation
);
